import { EmulateHeaders, gqlClient, graphql, queryClient } from '@tyro/api';
import { printingKeys } from './keys';

const printFireDrill = graphql(/* GraphQL */ `
  query print_fireDrill {
    print_fireDrill {
      url
      html
    }
  }
`);

const printFireDrillQuery = (academicNameSpaceId?: number) => ({
  queryKey: printingKeys.fireDrill(academicNameSpaceId),
  staleTime: 0,
  queryFn: async () =>
    gqlClient.request(
      printFireDrill,
      {},
      academicNameSpaceId
        ? {
            [EmulateHeaders.ACADEMIC_NAMESPACE_ID]:
              academicNameSpaceId.toString(),
          }
        : {},
    ),
});

export function getPrintFireDrill(academicNamespaceId?: number) {
  return queryClient.fetchQuery(printFireDrillQuery(academicNamespaceId));
}
